"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var BrandLanguageEditor = /** @class */ (function (_super) {
    __extends(BrandLanguageEditor, _super);
    function BrandLanguageEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandLanguageEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    is_default: _item.is_default,
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                is_default: false
            });
        }
        this.doReSetRules();
    };
    BrandLanguageEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
        });
    };
    BrandLanguageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        return true;
    };
    /*private OnUpdateDataClick() {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                is_default: this.state.is_default
            }, () => {
                notificationHelper.ShowTextTopRightInfoNotify("Язык бренда изменен!");
            })
        }
    }*/
    BrandLanguageEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                brand_id: this.props.rootRecord.key,
                is_default: this.state.is_default
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Язык бренда добавлен!");
            });
        }
    };
    BrandLanguageEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandLanguageEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить язык бренда";
        }
        else {
            return "Изменить язык бренда";
        }
    };
    BrandLanguageEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguage, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Основной язык", value: this.state.is_default, onChecked: function (checked) { _this.setState({ is_default: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return BrandLanguageEditor;
}(React.Component));
exports.default = BrandLanguageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/language/BrandLanguageEditor.tsx
// module id = 1767
// module chunks = 0